import modalTemplate from './view.html';

import { CourseModalController } from './controller';

import { COURSE_MODAL_CONTROLLER } from '../../const';

class CourseModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    open = (courseId = 0) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: COURSE_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'md',
            resolve: {
                courseId: courseId,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    CourseModalController,
    CourseModal,
};
